import { Injectable } from '@angular/core';

import { PageMeta } from '@spartacus/core';
import { SeoMetaService } from '@spartacus/storefront';

@Injectable()
export class DpSeoMetaService extends SeoMetaService {
  protected set meta(meta: PageMeta) {
    this.title = meta.metaTitle ?? meta.title;
    this.description = meta.description;
    this.image = meta.image;
    this.robots = meta.robots;
    this.canonicalUrl = meta.canonicalUrl;
  }
}
